<template>
    <div class="col">

        <div id="main"
             class="col-main">

            <div class="row no-gutters row-main justify-content-center">

                <div class="col-12 col-lg-10 bg-white">

                    <div class="row no-gutters justify-content-center">
                        <div class="col-12 col-lg-9">
                            <h2 class="section-title">Cricket for Girls & Boys of all abilities ages 5 to 17</h2>
                        </div>

                        <div class="col-12 col-lg-9">
                            <!-- Text -->
                            <p class="h5">We are an England Cricket Board (ECB) Clubmark accredited club, playing winter 
                                & summer cricket in the <a href="https://mjcacricket.org/" target="_blank" rel="noreferer">
                                    Middlesex Junior Cricket Association leagues</a>. 
                            </p>

                            <p class="text-strong">See our fixtures and results <a href="https://www.play-cricket.com/" target="_blank" rel="noreferer">here</a>.</p>

                            <p class="text-strong">
                                Training
                            </p>
                            <p>
                                The club runs structured winter and summer training with ECB qualified coaches which take advantage of the top class Trailfinders facilities.
                                Our coaches will teach your child throughout the year the basics of cricket: batting, bowling, fielding and game awareness in a fun and participative atmosphere. Over time we will introduce the juniors to the longer forms of the game and eventually to a full adult game of cricket. 
                                We aim to give every junior competitive cricket during the year. From the age of 13 our juniors are encouraged to play with the adult teams to become our cricketers of the future.
                                Join our community <a v-bind:href="'#/register?form=junior'">here</a>. 
                            </p>


                            <p class="text-strong">OECB All Stars & Dynamos Cricket</p>
                             
                            <p>
                                The ECB All Stars & Dynamos cricket programmes are run at the club. Details are available in the spring term.
                            </p>
                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>
</template>
<script>
    export default {
        // data() {
        //     return {
        //         model: {}
        //     }
        // },
        // methods: {
        //     fetchList() {
        //         fetchUser('5e42c8d3a366ce0f8dfc4bf9')
        //             .then(response => {
        //                 this.model = response;
        //             })
        //     },
        // }
    }
</script>
<style>
</style>
